var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNull({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_410",
    "data-name": "Grupo 410",
    transform: "translate(-1814 -1337)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_323",
    "data-name": "Rect\\xE1ngulo 323",
    width: 13,
    height: 4,
    rx: 1,
    transform: "translate(1820 1347)",
    fill: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_324",
    "data-name": "Rect\\xE1ngulo 324",
    width: 24,
    height: 24,
    transform: "translate(1814 1337)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNull);
export default __webpack_public_path__ + "static/media/null.66e9a60feaf0f2a8c6014d181be0c3e4.svg";
export { ForwardRef as ReactComponent };